// DasboardView.jsx
import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ProductStatus from "./productStatus/productStatus";
import FinalView from "./finalView/finalView";
import SampleStatus from "./SampleStatus/SampleStatus";
import SampleTrend from "./SampleTrend/SampleTrend";

const DasboardView = ({ data = {} }) => {
  const {
    productStatistics,
    sampleStatusCounts,
    finalReviewSamples,
    totalTurnAroundTime,
    totalSamplesReceived,
    samplesTested,
    percentageMetric,
  } = data;
  const sampleTrendData = {
    totalTurnAroundTime,
    totalSamplesReceived,
    samplesTested,
    percentageMetric, 
  };
  return (
    <Container fluid className="bg-light">
      {/* Top Section: Product Status & Sample Status + Sample Trend in single column */}
      <Row className="mb-4">
        <Col lg={9}>
          <ProductStatus data={productStatistics} />
        </Col>
        <Col lg={3}>
          <SampleStatus data={sampleStatusCounts} />
        </Col>
      </Row>

      {/* Bottom Section: Final Review */}
      <Row>
        <Col lg={9}>
          <FinalView data={finalReviewSamples} />
        </Col>
        <Col lg={3}>
          <SampleTrend data={sampleTrendData} />
        </Col>
      </Row>
    </Container>
  );
};

export default DasboardView;
